import React from "react"
import Menu, { MenuProps } from "./Menu"
import "./index.scss"

interface FiltersProps {
	dataMenu: MenuProps
	children: JSX.Element
}

const Filters: React.FC<FiltersProps> = ({ children, dataMenu }) => {
	return (
		<React.Fragment>
			<div className="filters-select-container">{children}</div>
			<Menu panelContent={dataMenu.panelContent} buttons={dataMenu.buttons} />
		</React.Fragment>
	)
}

export default Filters
